const COMPONENT_LABELS = {
    examination: 'Bác sĩ khám',
    treatment: 'Bác sĩ điều trị',
    implant_placement: 'Bác sĩ cắm trụ',
    prosthetic_restoration: 'Bác sĩ phục hình',
    apprentice: 'Bác sĩ học việc',
    full_service: 'Nhân sự thực hiện (dữ liệu cũ)',
};

const employeeName = event => event?.employee?.full_name || (event?.employee_id ? `#${event.employee_id}` : null);

export const buildAppointmentStaffHistoryRows = events => {
    const groups = new Map();
    (Array.isArray(events) ? events : []).forEach(event => {
        const name = employeeName(event);
        if (!event?.id || !name || !event.event_at || !['ASSIGNED', 'REMOVED'].includes(event.event_type)) return;

        const componentKey = event.component_key || 'full_service';
        const changeBatchKey = event.source_snapshot?.change_batch_key || event.event_at;
        const key = [event.appointment_service_id || 0, componentKey, changeBatchKey].join('|');
        if (!groups.has(key)) {
            groups.set(key, {
                key,
                componentKey,
                label: event.role_key === 'assistant' ? 'Phụ tá' : (COMPONENT_LABELS[componentKey] || 'Vai trò chưa xác định'),
                eventAt: event.event_at,
                actor: event.actor,
                removed: [],
                assigned: [],
            });
        }
        const target = event.event_type === 'REMOVED' ? groups.get(key).removed : groups.get(key).assigned;
        if (!target.includes(name)) target.push(name);
    });

    return Array.from(groups.values())
        .filter(row => row.removed.length || row.assigned.length)
        .sort((left, right) => String(right.eventAt).localeCompare(String(left.eventAt)));
};

export const appointmentStaffHistoryChangeText = row => (
    `${row?.removed?.join(', ') || '—'} → ${row?.assigned?.join(', ') || '—'}`
);

export const getAppointmentStaffHistoryAction = row => {
    if (row?.removed?.length && row?.assigned?.length) return { label: 'Thay thế', color: 'blue' };
    if (row?.assigned?.length) return { label: 'Thêm mới', color: 'green' };
    return { label: 'Xóa nhân sự', color: 'red' };
};
